import { useFeatureFlag } from "@jsq/flags-react";

export const useLPComplianceUXv2 = () => {
  const enableLPComplianceUXv2 = useFeatureFlag("enableLPComplianceUXv2", false);
  return enableLPComplianceUXv2;
};

export const useDocumentRefreshEnabled = () => {
  const enableDocumentRefresh = useFeatureFlag("enableDocumentRefresh", false);
  return enableDocumentRefresh;
};

export const useGuidedProfileCreation = () => {
  const guidedProfileCreation = useFeatureFlag("guidedProfileCreation", false);
  return guidedProfileCreation;
};
